import type { FactoryConfig } from './types';
import { api } from './core';

let _config: FactoryConfig | null = null;

export async function loadFactoryConfig(): Promise<FactoryConfig> {
    if (_config) return _config;
    try {
        _config = await api('/api/factory-config') as FactoryConfig;
    } catch (e) {
        _config = {
            factory_name: 'MaintControl',
            factory_code: 'DEFAULT',
            production_lines: [],
            features: {
                ai_chat: true,
                energy_monitoring: true,
                quality_module: true,
                '3d_models': true,
            },
        };
    }
    return _config;
}

export function getFactoryConfig(): FactoryConfig | null {
    return _config;
}

export function isFeatureEnabled(feature: string): boolean {
    if (!_config || !_config.features) return true;
    return _config.features[feature] !== false;
}

export function applyFactoryTheme(config: FactoryConfig): void {
    if (!config.theme) return;

    const { primary_color, sidebar_title, sidebar_subtitle } = config.theme;

    if (primary_color) {
        document.documentElement.style.setProperty('--primary', primary_color);
    }

    if (sidebar_title) {
        const titleEl = document.querySelector('.sidebar-header h2');
        if (titleEl) titleEl.textContent = sidebar_title;
    }

    if (sidebar_subtitle) {
        const subtitleEl = document.querySelector('.sidebar-header .subtitle');
        if (subtitleEl) subtitleEl.textContent = sidebar_subtitle;
    }

    if (config.factory_name) {
        document.title = `${config.factory_name} — MaintControl`;
    }
}
